var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}arrow_corner-12`,"viewBox":"0 0 12 8"}},[_c('path',{staticClass:"sign arrow",attrs:{"d":"M1 1.5L6 6.5L11 1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }